import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaStepsService } from '../ta-steps.service';

@Component({
  selector: 'app-ta-steps',
  templateUrl: './ta-steps.component.html',
  styleUrls: ['./ta-steps.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TaStepsComponent implements OnInit {
  parent_id: number;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public service: TaStepsService
  ) {}

  ngOnInit() {
    // get the site id
    this.parent_id = Number(this.route.snapshot.params['ta_id']);

    if (this.parent_id) {
      // get the list of codes
      this.service.get(this.parent_id, 0, true);
    } else {
      // redirect back to sites because the site id is not valid
      this.router.navigate(['task-analyses']);
    }
  }

  onRemove(id: number) {
    this.service.remove(this.parent_id, id);
  }
}
